/**
 * Email validation helper.
 *
 * Single source of truth for email-format checks across app-web. Previously
 * this regex was duplicated inline in UserComponents/Invite.jsx and
 * UserComponents/Edit.jsx, and a parallel copy lived in Inputs/Inputs.jsx.
 * Keep behavior identical to the legacy regex — do not "improve" the pattern
 * here without explicit sign-off; consumers depend on its current acceptance
 * set.
 */

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function isEmail (value: unknown): boolean {
  if (typeof value !== 'string') return false
  return EMAIL_REGEX.test(value)
}

export { EMAIL_REGEX }
